module.exports = __webpack_public_path__ + "img/IMG_6408.9cd73e31.png";